import {
  TRANSFORMERS,
} from '@lexical/markdown';
import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import React from 'react';
import $convertToMarkdownString from './forks/convertToMarkdownString';
import PlaygroundNodes from './nodes/PlaygroundNodes';
import StyledDiv from './styles';
import PlaygroundEditorTheme from './themes/PlaygroundEditorTheme';
import Placeholder from './ui/Placeholder';

function onError(error: Error) {
  console.error('Error rendering rich text', error);
}

function InnerRichTextRenderer(props: { value: string, setText?: (value: string) => void, emptyText?: string }) {
  const { value, setText, emptyText } = props;

  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    if (setText) {
      const parsedEditorState = editor.parseEditorState(value);
      const editorStateTextString = parsedEditorState.read(() => $convertToMarkdownString(TRANSFORMERS, undefined, true));
      setText(editorStateTextString);
    }
  }, [editor, value]);
  return (
    <RichTextPlugin
      contentEditable={(
        <ContentEditable />
      )}
      ErrorBoundary={LexicalErrorBoundary}
      {...emptyText && { placeholder: <Placeholder>{emptyText}</Placeholder> }}
    />
  );
}

export default function RichTextRenderer(props: { value: string, setText?: (value: string) => void, emptyText?: string }) {
  const {
    value, setText, emptyText,
  } = props;
  const initialConfig: InitialConfigType = {
    editorState: value,
    namespace: 'CogNeed',
    nodes: [...PlaygroundNodes],
    onError,
    theme: PlaygroundEditorTheme,
    editable: false,
  };

  const [ref, setRef] = React.useState<HTMLDivElement | null>(null);
  React.useEffect(() => {
    if (ref) {
      ref.querySelectorAll('a').forEach((link) => {
        link.setAttribute('target', '_blank');
      });
    }
    return undefined;
  }, [ref]);

  return (
    <StyledDiv>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div onClick={(e) => { e.stopPropagation(); }} ref={(r) => { setRef(r); }}>
        <LexicalComposer
          initialConfig={initialConfig}
        >
          <InnerRichTextRenderer value={value} setText={setText} emptyText={emptyText} />
        </LexicalComposer>
      </div>
    </StyledDiv>
  );
}
